import React, { Component } from 'react';
import { connect } from 'react-redux';
import { mapStateToPropsWrapper, verificationProps } from '../../CaptureErreurs';
// Pour Fonctionner ce composant a besoin que le parent lui passe la fonction ChangeState et sont state où il doit y avoir
//         this.state = {
//             IBAN:'',
//             BIC:'',
//         };

const ChampsIBAN = ({
    nom, id, valeurChamps, CollerIBAN, onChange, ClavierAction,
}) => (
    <div className="col-12 col-sm " style={{ padding: 0 }}>
        <input
            className="m-1 form-control h-75"
            type="text"
            name={nom}
            id={id}
            onPaste={CollerIBAN}
            value={valeurChamps}
            maxLength="4"
            onKeyDown={ClavierAction}
            onChange={onChange}
            style={{ width: 65 }}
        />
    </div>
);

class FormSaisieRIB extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ChampsIBAN: '',
            ChampsIBAN1: '',
            ChampsIBAN2: '',
            ChampsIBAN3: '',
            ChampsIBAN4: '',
            ChampsIBAN5: '',
            ChampsIBAN6: '',
            ChampsIBAN7: '',
            ChampsBIC: '',
        };
        this.handleCollerIBAN = this.CtrlCollerIBAN.bind(this);
        this.handleCollerBIC = this.CtrlCollerBIC.bind(this);
    }

    // Préchargement de l'iban dans les champs (retiré pour le moment)
    // componentWillMount() {
    //     if (
    //         this.props.Rib !== 'undefined' &&
    //         this.props.Rib.Iban !== 'undefined' &&
    //         this.props.Rib.Bic !== 'undefined'
    //     ) {
    //         const Iban = this.props.Rib.Iban.replace(/ /g, '');
    //         this.setState({ ChampsBIC: this.props.Rib.Bic.replace(/ /g, '') });
    //         this.setState({ ChampsIBAN: Iban.substring(0, 4).toUpperCase() });
    //         this.setState({ ChampsIBAN1: Iban.substring(4, 8).toUpperCase() });
    //         this.setState({ ChampsIBAN2: Iban.substring(8, 12).toUpperCase() });
    //         this.setState({ ChampsIBAN3: Iban.substring(12, 16).toUpperCase() });
    //         this.setState({ ChampsIBAN4: Iban.substring(16, 20).toUpperCase() });
    //         this.setState({ ChampsIBAN5: Iban.substring(20, 24).toUpperCase() });
    //         this.setState({ ChampsIBAN6: Iban.substring(24, 28).toUpperCase() });
    //         this.setState({ ChampsIBAN7: Iban.substring(28, this.props.Rib.Iban.length).toUpperCase() });
    //     }
    // }
    // componentDidMount() {
    //     this.CreerIBAN();
    // }
    CtrlCollerBIC(event) {
        let coller = event.clipboardData.getData('Text');
        coller = coller.replace(/ /g, '');
        coller = coller.trim();
        this.setState({ ChampsBIC: coller.toUpperCase() }, () => this.CreerIBAN());
    }
    CtrlCollerIBAN(event) {
        let coller = event.clipboardData.getData('Text');
        let i = 0;
        let indiceChamp = '';
        let indicePressePapierDeb = 0;
        let indicePressePapierFin = 0;
        coller = coller.replace(/ /g, '');
        coller = coller.trim();

        for (i = 0; i < 8; i += 1) {
            if (i > 0) {
                indiceChamp = i;
            }

            const champsStateModif = document.getElementById(`IBAN${indiceChamp}`);
            indicePressePapierDeb = i * 4;
            indicePressePapierFin = indicePressePapierDeb + 4;

            if (indicePressePapierFin >= coller.length) {
                indicePressePapierFin = coller.length;

                this.setState(
                    {
                        [`Champs${champsStateModif.id}`]: coller.substring(
                            indicePressePapierDeb,
                            indicePressePapierFin,
                        ).toUpperCase(),
                    },
                    () => this.CreerIBAN(),
                );
                champsStateModif.focus();
                champsStateModif.select();
                break;
            }

            this.setState(
                {
                    [`Champs${champsStateModif.id}`]: coller.substring(indicePressePapierDeb, indicePressePapierFin).toUpperCase(),
                },
                () => this.CreerIBAN(),
            );
            champsStateModif.focus();
            champsStateModif.select();
        }
    }
    CreerIBAN() {
        // On Concatène tous les state ChampsIBAN pour que le parent n'ai plus qu'un champs IBAN pour la validation
        const PropState = this.state;
        let IBANComplet =
            PropState.ChampsIBAN +
            PropState.ChampsIBAN1 +
            PropState.ChampsIBAN2 +
            PropState.ChampsIBAN3 +
            PropState.ChampsIBAN4 +
            PropState.ChampsIBAN5 +
            PropState.ChampsIBAN6 +
            PropState.ChampsIBAN7;
        IBANComplet = IBANComplet.replace(/ /g, '');
        this.props.ChangeState('IBAN', IBANComplet);
        this.props.ChangeState('BIC', PropState.ChampsBIC);
    }

    ClavierActionIBAN = (nomChampSuiv, nomChampPrec) => {
        const evt = window.event;
        const { target } = evt;
        const champsName = target.name;
        let code = -1;
        let ProchainFocus;
        code = evt.keyCode;
        // Si c'est pas une touche alphanumerique ou les fléche on part
        if (code >= 0 && code !== 8 && code !== 37 && code !== 39 && code < 46) return;
        // test de la touche supprimer pour passer au champ
        if (code === 8 || code === 37) {
            if (champsName !== 'ChampsIBAN' && (target.value === '' || (target.selectionStart === 0 && target.selectionEnd === target.selectionStart))) {
                ProchainFocus = target.form.elements[nomChampPrec];
                ProchainFocus.focus();
                ProchainFocus.selectionEnd = ProchainFocus.value.length;
            }
        } else if (nomChampSuiv && (target.selectionEnd >= 4 || target.value.length === 4)) {
            // Si le curseur est a la fin de la textbox on passe a la suivante
            if (code === 39 && target.selectionEnd < 4) return;
            ProchainFocus = target.form.elements[nomChampSuiv];
            ProchainFocus.focus();
            ProchainFocus.select();
            ProchainFocus.selectionEnd = 0;
        }
    };
    AideSaisie = () => {
        // Recupere l'evenement
        const evt = window.event;
        const { target } = evt;
        const inputTypeEvt = evt.inputType;
        if (inputTypeEvt !== 'undefined' && inputTypeEvt === 'insertFromPaste') return;
        const champsName = target.name;
        const saisie = target.value;
        // Si c'est different de l'insetion/supression de texte alors on sort
        // Set le State de l'enfant et attend la màj du state enfant pour lancer CreeIban qui va modifier le state du parent
        this.setState(
            {
                [champsName]: saisie.toUpperCase(),
            },
            () => this.CreerIBAN(),
        );
    };
    render() {
        // Boucle pour creer les composant champsIban
        const leState = [
            { NomState: 'ChampsIBAN', valeur: this.state.ChampsIBAN },
            { NomState: 'ChampsIBAN1', valeur: this.state.ChampsIBAN1 },
            { NomState: 'ChampsIBAN2', valeur: this.state.ChampsIBAN2 },
            { NomState: 'ChampsIBAN3', valeur: this.state.ChampsIBAN3 },
            { NomState: 'ChampsIBAN4', valeur: this.state.ChampsIBAN4 },
            { NomState: 'ChampsIBAN5', valeur: this.state.ChampsIBAN5 },
            { NomState: 'ChampsIBAN6', valeur: this.state.ChampsIBAN6 },
            { NomState: 'ChampsIBAN7', valeur: this.state.ChampsIBAN7 },
        ];
        const IBANChamps = leState.map((state, index) => (
            <ChampsIBAN
                key={index}
                nom={state.NomState}
                id={state.NomState.substring(6, state.NomState.length)}
                valeurChamps={state.valeur}
                CollerIBAN={this.handleCollerIBAN}
                ClavierAction={() => {
                    // eslint-disable-next-line no-nested-ternary
                    this.ClavierActionIBAN(
                        index < 7 ? `IBAN${index + 1}` : null,
                        index > 0 ? (index === 1 ? 'IBAN' : `IBAN${index - 1}`) : null,
                    );
                }}
                onChange={this.AideSaisie}
            />
        ));

        return (
            <form className="mt-3" onSubmit={this.handleSubmit}>
                <div className="form-row mb-2 mt-2" style={{ minWidth: 488, maxWidth: 688 }}>
                    <div className="col-2 align-self-center">
                        <div className="row" style={{ minWidth: 88, maxWidth: 108 }}>
                            <div className="col text-left">
                                <strong>IBAN</strong>
                            </div>
                            <div className="col align-self-center text-right">
                                <strong>:</strong>
                            </div>
                        </div>
                    </div>
                    <div className="row" style={{ minWidth: 580, maxWidth: 600 }}>
                        {IBANChamps}
                    </div>
                </div>
                <div className="form-row mt-2 " style={{ minWidth: 488, maxWidth: 688 }}>
                    <div className="col-2 align-self-center">
                        <div className="row" style={{ minWidth: 88, maxWidth: 108 }}>
                            <div className="col text-left">
                                <strong>BIC</strong>
                            </div>
                            <div className="col align-self-center text-right">
                                <strong>:</strong>
                            </div>
                        </div>
                    </div>
                    <div className="row " style={{ minWidth: 580, maxWidth: 600 }}>
                        <input
                            type="text"
                            className="m-1 form-control h-75 w-50"
                            id="BIC"
                            name="ChampsBIC"
                            value={this.state.ChampsBIC}
                            onPaste={this.handleCollerBIC}
                            onChange={() => {
                                this.AideSaisie();
                            }}
                        />
                    </div>
                </div>
            </form>
        );
    }
}
FormSaisieRIB.displayName = 'FormSaisieRIB';
FormSaisieRIB.requiredProps = [];

// function mapStateToProps({
//     ProStore: {
//         Pro: { Rib },
//     },
// }) {
//     return {
//         Rib,
//     };
// }

export default connect(mapStateToPropsWrapper())(verificationProps(FormSaisieRIB));



// WEBPACK FOOTER //
// ./src/components/MesInfos/Prelevement/FormSaisieRIB.js